import { UPDATE } from 'react-admin';

export const SEND_APPROVAL = 'SEND_APPROVAL';
export const sendApprovalRequest = (id, data, basePath) => ({
    type: SEND_APPROVAL,
    payload: { id, data: { ...data, is_sent: true, is_approved: false } },
    meta: { fetch: UPDATE, resource: 'emails' },
});